import React, { useRef } from 'react';
import { CustomNotification } from 'common/components';
import { useSelector, useDispatch } from 'react-redux';
import { RibbonBar, RibbonDivider, RibbonSection } from 'common/components';
import { ViewLayout } from './components';
import GridViewSelector from 'common/components/grid-view/controllers/selectors';
import { Menu, Dropdown } from 'antd';
import RibbonButton from 'common/components/button/RibbonButton';
import * as globalActions from '@redux/global/actions';
import { FileTextOutlined,  FolderOpenOutlined } from '@ant-design/icons';
import { forwardTo } from 'utils/common/route';
import DetailSection from './components/sections/home-grid/DetailSection';
import { Can } from 'context/Can';
import { ABILITY_ACTION, ABILITY_SUBJECT } from 'static/Permission';
import DetailSection from './components/sections/home-grid/DetailSection';
import CertificateModalManager from '../../branded-assets-certificates/components/panel/CertificateModalManager';
import { useCheckAllowEditContact } from 'hooks/useCheckIsSuperUser';
import {
  useCheckIsSuperAdmin
} from 'hooks';


const CertificatesGrid = () => {
  const selectedCertificateDetail = useSelector(
    GridViewSelector.makeSelectDetailCurrentITemsSelection()
  );
  const certificateId =
    selectedCertificateDetail && selectedCertificateDetail.length > 0
      ? selectedCertificateDetail[0].id
      : undefined;
  const dispatch = useDispatch();
  // selection helpers
  const detailSelectedItems = useSelector(
    GridViewSelector.makeSelectDetailCurrentITemsSelection()
  );
  const selectedItem = useSelector(
    GridViewSelector.makeSelectItemCurrentSelection()
  );
  const isDisabled = certificateId === undefined || selectedCertificateDetail.length !== 1;


  const hasPermissionCertificateEdit = useCheckAllowEditContact();
  const isSuperAdmin = useCheckIsSuperAdmin();


  const enableManageLinks = (isSuperAdmin || hasPermissionCertificateEdit);

  const modalRef = useRef({});

  const handleExpose = (handlers) => {
    modalRef.current = handlers;
  };
  const menu = (
    <Menu>
      <Menu.Item key="add" onClick={() => modalRef.current.handleAdd()}>
        Add Certificate
      </Menu.Item>
      <Menu.Item
        key="update"
        onClick={() => {
          if (selectedCertificateDetail?.length === 1) {
            modalRef.current.handleEdit(selectedCertificateDetail[0]);
          } else {
            CustomNotification.warning('Please select one certificate to edit');
          }
        }}
        disabled={isDisabled}
      >
        Update Certificate
      </Menu.Item>
      <Menu.Item
        key="delete"
        onClick={() => {
          if (selectedCertificateDetail?.length === 1) {
            modalRef.current.handleDelete(selectedCertificateDetail[0]);
          } else {
            CustomNotification.warning('Please select one certificate to delete');
          }
        }}
        disabled={isDisabled}
      >
        Delete Certificate
      </Menu.Item>
      <Menu.Item
        key="download"
        onClick={() => {
          if (selectedCertificateDetail?.length === 1) {
            modalRef.current.handleDownload(selectedCertificateDetail[0]);
          } else {
            CustomNotification.warning('Please select one certificate to download');
          }
        }}
      >
        Download Certificate
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <RibbonBar>

        <Can I={ABILITY_ACTION.VIEW} a={ABILITY_SUBJECT.ASSET}>
          <DetailSection />
        </Can>
        <Can I={ABILITY_ACTION.VIEW} a={ABILITY_SUBJECT.ASSET}>
          <RibbonSection>
            <ViewLayout />
          </RibbonSection>
        </Can>
        <Can I={ABILITY_ACTION.VIEW} a={ABILITY_SUBJECT.ASSET}>
          <RibbonSection>
            <RibbonButton
              icon={<FolderOpenOutlined />}
              label='Open'
              onClick={() => forwardTo(`/certificate/${certificateId}`)}
              disabled={isDisabled}
            />
          </RibbonSection>
        </Can>
        <RibbonDivider />
        {enableManageLinks && (
          <RibbonSection>
            <Dropdown overlay={menu} placement="bottomLeft">
              <RibbonButton label={'Certification Actions'} disabled={isDisabled} icon={<FileTextOutlined />} />
            </Dropdown>
          </RibbonSection>
        )}
      </RibbonBar>
      <CertificateModalManager isDetailPage={false} onExpose={handleExpose} />
    </>
  );
};

export default CertificatesGrid;
